import React, { Component } from 'react';

class CheckBoxImprimir extends Component {

    //CHECKBOX IMPRIMIR
    render () {
        return (
            <div className="row">
                <div className="col-md-10">
                </div>
                <div className="col-md-2">
                    <label className="checkbox-inline"><input type="checkbox" name="rb"></input>Imprimir al finalizar</label>
                </div>
            </div>
        );
    }
};

export default CheckBoxImprimir